import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

const ErrorMessageWrapper = styled.p`
  display: flex;
  padding-left: 5px;
  text-align: left;
`;

//translating errors from portal & triage
const errorMessageMapping = message => {
  switch (message) {
    case 'Incorrect email or password':
      return 'Login failed; invalid email or password. Please try again. If you forgot your password, please click the “Forgot Your Password” button.';
    case 'Incorrect login information':
      return 'We didn’t recognize this email or password. Please try again with an email and password that is associated with this project or click “Contact Us” for assistance.';
    default:
      return message;
  }
};

// need be compatible for different versions of errors
export const parseErrors = errors => {
  if (_.isEmpty(errors)) return; // non-error state

  if (_.isArray(errors) && !_.isEmpty(errors[0].response)) {
    const response = errors[0].response;

    if (_.isArray(response)) {
      return response[0].message || response[0].error;
    }
    if (!_.isEmpty(response.errors)) {
      return errorMessageMapping(response.errors[0]);
    }
  }

  return `An error has occurred. Please try again in a few minutes, or click "Contact Us" for assistance.`;
};

const ErrorMessage = ({ errors, message }) => {
  const err = parseErrors(errors);
  if (message || err) {
    return (
      <ErrorMessageWrapper>
        <span role="img" aria-label="error icon">
          ⚠️️
        </span>
        {message || err}
      </ErrorMessageWrapper>
    );
  }
  return <div />;
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.js